const MainFooter = () => import("@/components/MainFooter/MainFooter.vue")
const DisconnectButton = () => import("@/_partials/Buttons/Disconnect/Disconnect.vue")
import { EMPLOYEE_MENU } from "@/constants/employeeMenu";
import { mapGetters, mapActions } from 'vuex';
import Utils from "@/mixins/Utils";
import conditionHelper from "@/helpers/condition";
import notificationService from "../../services/notification";
import { TypeNotifications } from "../../constants/notification";

export default {
  components: {
    MainFooter,
    DisconnectButton,
  },
  data() {
    return {
      navBarItemsFirstChunk: EMPLOYEE_MENU.FIRST_CHUNK,
      navBarDropdowns: EMPLOYEE_MENU.CHUNK_WITH_DROPDOWN,
      navBarItemsChunk12: EMPLOYEE_MENU.SECOND_CHUNK,
      navBarItemsSecondChunk: EMPLOYEE_MENU.THIRD_CHUNK,
      listAccessItem: ['Mes congés', 'Notes de frais'],
      isShowChat: false,
      numberUnreadConversation: 0,
      numberNotiInApp: 0,
      countContentConversationsInterval: undefined,
      countNotificationsInterval: undefined

    };
  },
  watch:{
   
    $route(value) {
      if (value.name !=="employee-message") {
        if(!this.countContentConversationsInterval) {
          this.callIntervalNumberUnreadMessage();
        } 
      }
    },
   
   
  },

  mixins: [Utils],
  computed: {
    ...mapGetters("auth", {
      user: 'getUser',
      currentFrontendTech: 'getCurrentFrontendTech'
    }),
    ...mapGetters("chat", {
      numberUnreadConversations: 'numberUnreadConversations',
      isReachChatIcon: "isReachChatIcon",
      chatSettings: "chatSettings"
    }),

    ...mapGetters("notification", ['notifications', 'unreadNotifs', 'notificationConfig']),
    currentRouteFullName() {
      return this.$router.currentRoute.fullPath;
    },
    listNavBarItemsChunk12() {
      this.navBarItemsChunk12 = this.navBarItemsChunk12.filter(item => !item.hidden)
      return this.getNavBarItems(this.navBarItemsChunk12);
    },
    listNavBarDropdowns() {
      return this.navBarDropdowns.map(item => {
        const element = {};
        element.name = item.name;
        element.items = item.items.filter(child => !child.hidden);
        element.items = this.getNavBarItems(element.items);
        return element;
      })
    },
  },
  beforeCreate() {
    this.$store.dispatch("auth/CREATE_LAYOUT_INSTANCE");
  },
  created() {
   
 
    if(!this.countContentConversationsInterval && this.$route.name !=='employee-message') {
      this.callIntervalNumberUnreadMessage();
    } 

    let numberNotiInterval = 30000;
    if (!this.notificationConfig) {
      this.getNotificationConfig();
      if (localStorage.getItem("notificationConfig")) {
        numberNotiInterval = JSON.parse(localStorage.getItem("notificationConfig")).frequenceCallingCountNotifications ?  JSON.parse(localStorage.getItem("notificationConfig")).frequenceCallingCountNotifications* 1000 : 30000;

      }
    } else {
      numberNotiInterval = this.notificationConfig && this.notificationConfig.frequenceCallingCountNotifications ? this.notificationConfig.frequenceCallingCountNotifications * 1000 : 30000
    }


    this.getNumberNotiInApp();

    this.countNotificationsInterval = setInterval(() => {

      this.getNumberNotiInApp();
    }, numberNotiInterval)

  },
  beforeDestroy() {
    clearInterval(this.countContentConversationsInterval);
    clearInterval(this.countNotificationsInterval);
  },
  methods: {
    ...mapActions('notification', {
      getNotifications: 'GET_NOTIFICATIONS',
      getNotificationConfig: 'GET_NOTIFICATION_CONFIG'
    }),
    ...mapActions('chat', ['getNumberUnreadConversation']
    ),
    showNotification() {
      return conditionHelper('rcfnotificationadv');
    },
    callIntervalNumberUnreadMessage() {
      let numberUnreadMessageInterval = this.chatSettings && this.chatSettings.freqRefreshCountUnreadCons ? this.chatSettings.freqRefreshCountUnreadCons*1000 : 30000;
      this.getNumberUnreadConversation(this.user.pkCrf);
      this.countContentConversationsInterval = setInterval(()=> {
        this.getNumberUnreadConversation(this.user.pkCrf);
      },numberUnreadMessageInterval);
    },

   
    showMenu() {
      this.$refs["modalMenu"].toggle();
    },
    hideMenu() {
      this.$refs["modalMenu"].hide();
    },
    getNavBarItems(navBarItems) {
      //  this.isShowChat = false;
      let items = []
      navBarItems.forEach((item) => {
        if (item.key) {
          if (conditionHelper(item.key)) {
            items.push(item);
          }
        } else if (item.multiConditions && item.multiConditions.length) {
          const condition = item.multiConditions.find(item => conditionHelper(item));
          if (condition) {
            this.isShowChat = true;
            items.push(item);
          }
        } else {
          items.push(item);
        }
      });
      return items;
    },
    getNumberNotiInApp() {
      const param = {
        idPkUserType: 1,
        pkUser: this.user.pkCrf,
        keyFrontendTech: this.currentFrontendTech,
        isBackground: true,
        typeNotification: TypeNotifications.IN_APP
      };
      if (!this.currentFrontendTech) {
        notificationService.getFrontendTechs().then((result) => {

          const currTokenOS = 'ADV';
          if (result) {
            const webTech = result.frontendTechs.find(item => item.tokenMethod && item.tokenMethod.labelTokenMethod &&item.tokenMethod.labelTokenMethod === currTokenOS && item.isWebApp).key;
            this.$store.commit('auth/UPDATE_CURRENT_FRONTEND_TECH', webTech)
            param.keyFrontendTech = webTech;
            notificationService.getNumberCountNotiInApp(param).then((res) => {
              this.numberNotiInApp = res.nbNotificationUnread;
            });
          }
        })
      } else {
        notificationService.getNumberCountNotiInApp(param).then((res) => {
          this.numberNotiInApp = res.nbNotificationUnread;
        });

      }

    },

    onNavItemSameRoute(item) {
      if (this.$route.name === item.route) {
        this.$root.$emit('reset-support-form');
      }
    },
    onGo(item, mobileMode = false) {
      const vue = this;
      if (mobileMode) {
        this.hideMenu()
      }
      if (this.user.isMandataire && !this.user.isPrestataire && this.listAccessItem.includes(item.name)) {
        vue.callToaster(vue.$t('msg-access-right-for-madataire'));
      } else {
        this.$router.push({ name: item.route, params: item.params || {} })
      }
    },
    onClickChat() {
      if(!this.isReachChatIcon) {
        this.$store.commit("chat/SET_REACH_CHAT_ICON",true)
      }
      clearInterval(this.countContentConversationsInterval);
      this.countContentConversationsInterval = undefined;
       this.$router.push({ name: 'employee-message' });
    },
  }
};
